<template>
 <div class="nav-wrap" >
  <div class="nav-box" :style="`border-bottom-color: ${color}`">
    <div class="nav-list">
    <a :style="`color: ${color};`" :href="item.url" class="nav-item" v-for="(item, index) in nav" :key="index">{{
      item.name }}</a>

    <p class="contact-tel" :style="`color: ${color};`" v-if="!$isMobile">
      合伙人热线<br />
      <a :style="`color: ${color};`" href="tel:400-000-0000">400-891-0589</a>
    </p>
  </div>
  </div>
  <p class="contact-tel" :style="`color: ${color};`" v-if="$isMobile">
      合伙人热线<br />
      <a :style="`color: ${color};`" href="tel:400-000-0000">400-891-0589</a>
    </p>
 </div>
</template>
<style lang="less" scoped>
@media(max-width: 1200px) {
  .nav-wrap{
    position: relative;
    overflow: hidden;
    .contact-tel{
      width: 100% !important ;
      font-size: 3.33vw !important;
      line-height: 3.33vw !important;
      margin-top: 1.33vw !important;
      width: 27.467vw !important;
      float: right;
      a{
        letter-spacing: 1px !important;
      }
    }
  }
  .nav-box{
    padding-bottom: 1.333vw !important;
  }
  .nav-list{
    width: 86.667vw!important;
    flex-wrap: nowrap !important;
    justify-content: space-between !important;
    .nav-item{
      flex-shrink: 0;
      font-size: 3.33vw !important;
      line-height: 3.33vw !important;
    }
  }
}
.nav-wrap{
  width: 100%;
  .contact-tel {
    font-size: 33px;
    text-align: center;
    line-height: 26px;
    margin: 0;
    padding: 0;
    font-family: hanli-min,HL0811,Hl0906,Hl1126;
    a {
      letter-spacing: 3px;
    }
  }
  .nav-box{
    width: 100%;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    padding-bottom: 43px;
  }
}
.nav-list {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  font-family: hanli-min, HL0811,Hl0906,Hl1126;
  width: 1200px;
  margin: 0 auto;
  .nav-item {
    font-size: 33px;
    line-height: 32px;
  }

}
</style>
<script>
export default {
  props: {
    color: {
      type: String,
      default: '#473935'
    },
  },
  data() {
    return {
      nav: [
        {
          name: '首页',
          url: '/'
        },
        {
          name: '品牌故事',
          url: '/brand_story'
        },
        {
          name: '产品展示',
          url: '/product'
        },
        {
          name: '品牌资讯',
          url: '/brand_info'
        },
        {
          name: '门店分布',
          url: '/store'
        },
        {
          name: '联系我们',
          url: '/contact'
        }
      ]
    }
  }

}
</script>